export const MIN_NO_OF_POLL_QUESTION_OPTIONS = 2;
export const MAX_NO_OF_POLL_QUESTION_OPTIONS = 6;
export const POLL_QUESTION_MIN_FONT_SIZE = 14;
export const POLL_QUESTION_MAX_FONT_SIZE = 24;
export const POLL_BAR_MIN_HEIGHT = 24;
export const POLL_BAR_MAX_HEIGHT = 72;
export const POLL_SAVE_DEBOUNCE_TIME = 1000;
